// import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { PrevLoading } from './utils/loading'
import { BASE_URL } from '@/utils/host'

// 计数器
let count = 0

// 加载 loading
PrevLoading.start()
NProgress.configure({ showSpinner: false })

store.dispatch('user/getInfo')

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  if (get(to, 'meta.title')) {
    // document.title = to.meta.title
    document.title = 'PRIME AUTOLOAD'
  }
  const userInfo = store.getters.userInfo || {}
  if (to.path === '/login') {
    next()
  } else {
    if (!count && !isEmpty(userInfo)) {
      const accessRoutes = await store.dispatch('permission/getUserMenuList')
      // 动态添加可访问路由表
      router.addRoutes(accessRoutes)
      count++
      next({ ...to, replace: true })
    } else if (isEmpty(userInfo)) {
      window.location.replace(BASE_URL.GY_PASSPORT + '?redirect=' + encodeURIComponent(window.location.href))
    } else {
      next()
    }
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
  PrevLoading.done()
})
